import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function CarGuru(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#F1F5FB" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        d="M10.3387 13.324C9.88208 14.3267 8.95993 14.9266 7.88557 14.9266C6.34567 14.9266 5.10121 13.5747 5.10121 11.9184C5.10121 10.2621 6.35462 8.91021 7.88557 8.91021C8.99574 8.91021 9.89103 9.5011 10.3387 10.5128L10.3566 10.5575H11.5115L11.4757 10.4412C10.9654 8.82963 9.58663 7.8269 7.88557 7.8269C5.73687 7.8269 4 9.6533 4 11.9005C4 14.1477 5.73687 15.983 7.88557 15.983C9.56873 15.983 10.9475 14.9803 11.4757 13.3598L11.5115 13.2434H10.3655C10.3655 13.2613 10.3387 13.324 10.3387 13.324ZM7.63489 11.0231H8.36008V13.1449H7.63489V11.0231ZM9.33595 10.9336C9.56873 10.9336 9.75674 11.1216 9.75674 11.3544C9.75674 11.5871 9.56873 11.7751 9.33595 11.7751C9.10317 11.7751 8.91516 11.5871 8.91516 11.3544C8.92411 11.1216 9.11213 10.9336 9.33595 10.9336ZM6.65007 10.9336C6.88284 10.9336 7.07086 11.1216 7.07086 11.3544C7.07086 11.5871 6.88284 11.7751 6.65007 11.7751C6.41729 11.7751 6.22928 11.5871 6.22928 11.3544C6.22928 11.1216 6.41729 10.9336 6.65007 10.9336Z"
        fill="#EF3742"
      />
      <path
        d="M15.8266 12.0348V13.0107H18.2708L18.2976 12.9659C18.3692 12.8137 18.423 12.6525 18.4498 12.4914C18.4767 12.3392 18.5035 12.187 18.5035 12.0348H15.8266ZM18.9422 12.0348C18.8885 13.6732 17.7067 14.9087 16.2116 14.9087C14.6538 14.9087 13.3825 13.5568 13.3825 11.9184C13.3825 10.2621 14.6538 8.91917 16.2116 8.91917C17.268 8.91917 18.1723 9.51901 18.6378 10.5217L18.6557 10.5665H19.8465L19.8107 10.4501C19.2466 8.83859 17.841 7.80005 16.2205 7.80005C14.045 7.80005 12.2812 9.64435 12.2812 11.9005C12.2812 14.1566 14.045 16.0009 16.2205 16.0009C17.2143 16.0009 18.1633 15.607 18.8617 14.8997C19.6137 14.1387 20.0255 13.1002 19.9987 12.0258C19.9987 12.0348 18.9422 12.0348 18.9422 12.0348ZM16.1668 10.4859C16.4086 10.4859 16.6055 10.6829 16.6055 10.9246C16.6055 11.1664 16.4086 11.3633 16.1668 11.3633C15.9251 11.3633 15.7281 11.1664 15.7281 10.9246C15.7281 10.6829 15.9251 10.4859 16.1668 10.4859ZM17.8321 10.4859C18.0738 10.4859 18.2708 10.6829 18.2708 10.9246C18.2708 11.1664 18.0738 11.3633 17.8321 11.3633C17.5903 11.3633 17.3934 11.1664 17.3934 10.9246C17.3934 10.6829 17.5903 10.4859 17.8321 10.4859Z"
        fill="#00A0DD"
      />
    </svg>
  );
}

CarGuru.propTypes = propTypes;
CarGuru.defaultProps = defaultProps;

export default CarGuru;
